import { UnstyledButton, Group, Tooltip } from '@mantine/core';
import { ChevronUp, ChevronDown } from 'react-feather';
import classes from './SortableTableHeader.module.css';

export interface SortConfig {
  key: string;
  order: 'ASC' | 'DESC';
}

export interface SortableTableHeaderProps {
  label: string;
  sortKey: string;
  currentSort: SortConfig | null;
  onSort: (key: string) => void;
  align?: 'left' | 'center' | 'right';
}

function ColumnHeaderLabel({ label, className }: { label: string; className?: string }) {
  return (
    <Tooltip label={label} multiline w={300} withArrow position="top" openDelay={400}>
      <span
        className={className}
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical' as const,
          overflow: 'hidden',
          whiteSpace: 'normal',
          textOverflow: 'ellipsis',
          lineHeight: 1.35,
          maxHeight: '2.7em',
        }}
      >
        {label}
      </span>
    </Tooltip>
  );
}

export function NonSortableColumnHeader({ label }: { label: string }) {
  return (
    <span style={{ fontSize: 12, fontWeight: 600, display: 'block' }}>
      <ColumnHeaderLabel label={label} />
    </span>
  );
}

export function SortableTableHeader({
  label,
  sortKey,
  currentSort,
  onSort,
  align = 'left',
}: SortableTableHeaderProps) {
  const isSorted = currentSort?.key === sortKey;
  const isAsc = isSorted && currentSort?.order === 'ASC';
  const isDesc = isSorted && currentSort?.order === 'DESC';

  const handleClick = () => {
    onSort(sortKey);
  };

  return (
    <UnstyledButton onClick={handleClick} className={classes.header}>
      <Group gap={4} justify={align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start'} wrap="nowrap" align="center">
        <ColumnHeaderLabel label={label} className={classes.label} />
        <div className={classes.sortIcons} style={{ flexShrink: 0 }}>
          <ChevronUp
            size={12}
            className={`${classes.icon} ${isAsc ? classes.active : ''}`}
          />
          <ChevronDown
            size={12}
            className={`${classes.icon} ${isDesc ? classes.active : ''}`}
          />
        </div>
      </Group>
    </UnstyledButton>
  );
}

export default SortableTableHeader;
